import pagerConfig from 'config/pagerConfig'

export const paginate = (current, values) => {
  const lastItem = current * pagerConfig.PAGE_SIZE
  const firstItem = lastItem - pagerConfig.PAGE_SIZE
  const currentItems = values.slice(firstItem, lastItem)
  return currentItems
}
